import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { BillingEntity } from 'src/features/billing/utils/types';
import { GeneralASError } from 'src/registry/types/axios';
import { MoneyAccountFormSchemaValues } from 'src/features/moneyAccounts/utils/formSchema';

const RESOURCE = '/tenants/money-account/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends MoneyAccountFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<BillingEntity> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateMoneyAccount };
